export default "__VITE_ASSET__DaXXzGQo__"